import { errorEmitter } from './errorEmitter';
import { LOGGING_NAMESPACE } from './constants';
import { noWindow } from './noWindow';

export interface Logger {
    log: (...args: any[]) => void;
    error: (err: Error) => void;
}

declare global {
    export interface Window {
        silenceLogging: boolean;
    }
}

const logger: Logger = {
    log(...args: any[]) {
        if (!noWindow() && !window.silenceLogging) {
            // tslint:disable-next-line: no-console
            console.log(LOGGING_NAMESPACE, ...args);
        }
    },
    error(err: Error) {
        if (!noWindow() && !window.silenceLogging) {
            err.message = `${LOGGING_NAMESPACE}: ${err.message}`;
            errorEmitter(err);
        }
    },
}

export default logger;
